import { render, staticRenderFns } from "./SerpDialogTitle.vue?vue&type=template&id=3cec6046&scoped=true&"
import script from "./SerpDialogTitle.vue?vue&type=script&lang=js&"
export * from "./SerpDialogTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec6046",
  null
  
)

/* custom blocks */
import block0 from "./SerpDialogTitle.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports